import { useQuery } from "@tanstack/react-query";

import { getSite } from "../../api/queries"

export const useSite = (cityId: string) => useQuery(["site", cityId], () => getSite(cityId));
